import React, { useRef, useState, useEffect } from 'react'
import MoreButtonWrapper from '../Common/MoreButtonWrapper'
import { FEED_TASK_OBJECT_TYPE } from '../../../../Feeds/Utils/FeedsConstants'
import DeleteModalItem from './DeleteModalItem'
import { useSelector } from 'react-redux'
import { Keyboard } from 'react-native'
import {
    ESTIMATIONS_MODAL_ID,
    HIGHLIGHT_MODAL_ID,
    PRIVACY_MODAL_ID,
    PROJECT_MODAL_ID,
    RECURRING_MODAL_ID,
    removeModal,
    storeModal,
    TASK_DESCRIPTION_MODAL_ID,
    TASK_PARENT_GOAL_MODAL_ID,
    TASK_WORKFLOW_MODAL_ID,
} from '../../../../ModalsManager/modalsManager'
import DescriptionModal from '../../DescriptionModal/DescriptionModal'
import PrivacyModal from '../../PrivacyModal/PrivacyModal'
import RecurrenceModal from '../../RecurrenceModal'
import SelectProjectModal from '../../SelectProjectModal/SelectProjectModal'
import ProjectHelper from '../../../../SettingsView/ProjectsSettings/ProjectHelper'
import useGetTaskWorkflow from '../../../../../utils/useGetTaskWorkflow'
import StatusPicker from '../../../../TaskDetailedView/Properties/StatusPicker'
import FollowingModalItem from '../Common/FollowingModalItem'
import { FOLLOWER_TASKS_TYPE } from '../../../../Followers/FollowerConstants'
import GenericModalItem from '../Common/GenericModalItem'
import CopyLinkModalItem from '../Common/CopyLinkModalItem'
import TaskParentGoalModal from '../../TaskParentGoalModal/TaskParentGoalModal'
import Backend from '../../../../../utils/BackendBridge'
import v4 from 'uuid/v4'
import EstimationModal from '../../EstimationModal/EstimationModal'
import { getTaskAutoEstimation, objectIsPublicForLoggedUser } from '../../../../TaskListView/Utils/TasksHelper'
import { getEstimationIconByValue } from '../../../../../utils/EstimationHelper'
import { getDvMainTabLink } from '../../../../../utils/LinkingHelper'
import {
    setTaskAutoEstimation,
    setTaskHighlight,
    setTaskParentGoal,
    setTaskProjectWithGoal,
} from '../../../../../utils/backends/Tasks/tasksFirestore'
import HighlightColorModal from '../../HighlightColorModal/HighlightColorModal'
import { translate } from '../../../../../i18n/TranslationService'
import { isInboxSummaryGmailTask } from '../../../../../utils/Gmail/gmailTaskUtils'
import ModalItem from '../Common/ModalItem'
import TaskPriorityModal from '../../TaskPriorityModal/TaskPriorityModal'
import useFloatPopupLock from '../../../../../hooks/useFloatPopupLock'
import PrepareMeetingsItem from '../../PrepareMeetings/PrepareMeetingsItem'

export default function TaskMoreButton({
    formType,
    projectId,
    task,
    wrapperStyle,
    buttonStyle,
    disabled,
    saveDescription,
    dismissEditMode,
    updateActiveGoal,
    savePrivacyBeforeSaveObject,
    saveRecurrenceBeforeSaveTask,
    shortcut = 'M',
    isSuggestedTask,
    setEstimationBeforeSave,
    isAssistant,
    editing,
    setTempAutoEstimation,
    setPriorityBeforeSave,
    createSubtask,
}) {
    const loggedUserId = useSelector(state => state.loggedUser.uid)
    const [showDescription, setShowDescription] = useState(false)
    const [showParentGoal, setShowParentGoal] = useState(false)
    const [showPrivacy, setShowPrivacy] = useState(false)
    const [showRecurrence, setShowRecurrence] = useState(false)
    const [showProject, setShowProject] = useState(false)
    const [showWorkflow, setShowWorkflow] = useState(false)
    const [showEstimation, setShowEstimation] = useState(false)
    const [showHighlight, setShowHighlight] = useState(false)
    const [showPriority, setShowPriority] = useState(false)
    const [activeGoal, setActiveGoal] = useState(null)
    const modalRef = useRef()
    const popupLock = useFloatPopupLock()

    const hidePrivacyButton = !task.isSubtask && !task.done && task.userIds.length > 1
    const isLockedGmailTask = isInboxSummaryGmailTask(task)

    const link = `${window.location.origin}${getDvMainTabLink(projectId, task.id, 'tasks')}`
    const project = ProjectHelper.getProjectById(projectId)
    const workflow = useGetTaskWorkflow(projectId, task)
    const isGuide = !!project.parentTemplateId

    const dismissModal = () => {
        modalRef?.current?.close()
    }

    const openPopup = (e, constant, setVisibilityModal) => {
        e?.preventDefault()
        e?.stopPropagation()
        Keyboard.dismiss()
        if (constant) storeModal(constant)
        popupLock.acquire()
        setVisibilityModal(true)
    }

    const hidePopups = (setVisibilityModal, modalId) => {
        if (modalId) removeModal(modalId)
        popupLock.release()
        setVisibilityModal(false)
    }

    const hideDescriptionPopup = () => {
        hidePopups(setShowDescription, TASK_DESCRIPTION_MODAL_ID)
        dismissModal()
    }

    const hideParentGoalPopup = () => {
        hidePopups(setShowParentGoal, TASK_PARENT_GOAL_MODAL_ID)
        dismissModal()
    }

    const hidePrivacyPopup = () => {
        hidePopups(setShowPrivacy, PRIVACY_MODAL_ID)
        dismissModal()
    }

    const hideEstimationPopup = () => {
        hidePopups(setShowEstimation, ESTIMATIONS_MODAL_ID)
        dismissModal()
    }

    const hideHighlightPopup = () => {
        hidePopups(setShowHighlight, HIGHLIGHT_MODAL_ID)
        dismissModal()
    }

    const hidePriorityPopup = () => {
        hidePopups(setShowPriority)
        dismissModal()
    }

    const savePrivacy = (isPrivate, isPublicFor) => {
        savePrivacyBeforeSaveObject(isPrivate, isPublicFor)
    }

    const hideRecurrencePopup = () => {
        hidePopups(setShowRecurrence, RECURRING_MODAL_ID)
        dismissModal()
    }

    const hideProjectPopup = () => {
        hidePopups(setShowProject, PROJECT_MODAL_ID)
        dismissModal()
        dismissEditMode?.()
    }

    const hideWorkflowPopup = () => {
        hidePopups(setShowWorkflow, TASK_WORKFLOW_MODAL_ID)
        dismissModal()
        dismissEditMode?.()
    }

    const hideNoModalsProperties = () => {
        dismissModal()
        dismissEditMode?.()
        if (showHighlight) {
            setShowHighlight(false)
            removeModal(HIGHLIGHT_MODAL_ID)
            popupLock.release()
        }
        if (showPriority) {
            setShowPriority(false)
            popupLock.release()
        }
    }

    const startCreatingSubtask = e => {
        e?.preventDefault?.()
        e?.stopPropagation?.()
        dismissModal()
        dismissEditMode?.()
        setTimeout(() => createSubtask?.(), 10)
    }

    const onCloseMainModal = () => {
        if (showDescription) {
            setShowDescription(false)
            removeModal(TASK_DESCRIPTION_MODAL_ID)
            popupLock.release()
        }
        if (showPrivacy) {
            setShowPrivacy(false)
            popupLock.release()
        }
        if (showParentGoal) {
            setShowParentGoal(false)
            popupLock.release()
        }
        if (showRecurrence) {
            setShowRecurrence(false)
            removeModal(RECURRING_MODAL_ID)
            popupLock.release()
        }
        if (showProject) {
            setShowProject(false)
            removeModal(PROJECT_MODAL_ID)
            popupLock.release()
        }
        if (showWorkflow) {
            setShowWorkflow(false)
            removeModal(TASK_WORKFLOW_MODAL_ID)
            popupLock.release()
        }
        if (showEstimation) {
            setShowEstimation(false)
            removeModal(ESTIMATIONS_MODAL_ID)
            popupLock.release()
        }
        if (showHighlight) {
            setShowHighlight(false)
            removeModal(HIGHLIGHT_MODAL_ID)
            popupLock.release()
        }
        if (showPriority) {
            setShowPriority(false)
            popupLock.release()
        }
    }

    const renderItems = () => {
        const list = []

        if (editing && task.id && task.calendarData) {
            list.push(shortcut => (
                <PrepareMeetingsItem
                    key="mbtn-prepare-meetings"
                    projectId={projectId}
                    tasks={[task]}
                    specificTask={true}
                    shortcut={shortcut}
                    closeModal={hideNoModalsProperties}
                />
            ))
        }

        if (editing) {
            list.push(shortcut => {
                return (
                    <GenericModalItem
                        key={'mbtn-priority'}
                        icon={'flag'}
                        text={'Priority'}
                        visibilityData={{ openPopup, visibilityFn: setShowPriority }}
                        shortcut={shortcut}
                    />
                )
            })
        }

        if (editing) {
            list.push(shortcut => {
                return (
                    <CopyLinkModalItem
                        key={'mbtn-copy-link'}
                        link={link}
                        shortcut={shortcut}
                        onPress={hideNoModalsProperties}
                    />
                )
            })
        }

        if (editing && !task.isSubtask && !isAssistant && createSubtask) {
            list.push(shortcut => {
                return (
                    <ModalItem
                        key={'mbtn-create-subtask'}
                        icon={'plus-square'}
                        text={'Create subtask'}
                        shortcut={shortcut}
                        onPress={startCreatingSubtask}
                    />
                )
            })
        }

        if (!isAssistant) {
            list.push(shortcut => {
                return (
                    <GenericModalItem
                        key={'mbtn-estimation'}
                        icon={`count-circle-${getEstimationIconByValue(
                            projectId,
                            task.estimations[task.stepHistory[task.stepHistory.length - 1]]
                        )}`}
                        text={'Estimation'}
                        visibilityData={{ openPopup, constant: ESTIMATIONS_MODAL_ID, visibilityFn: setShowEstimation }}
                        shortcut={shortcut}
                    />
                )
            })
        }

        if (!task.calendarData && !isLockedGmailTask && !isAssistant) {
            list.push(shortcut => {
                return (
                    <GenericModalItem
                        key={'mbtn-description'}
                        icon={'info'}
                        text={'Description'}
                        visibilityData={{
                            openPopup,
                            constant: TASK_DESCRIPTION_MODAL_ID,
                            visibilityFn: setShowDescription,
                        }}
                        shortcut={shortcut}
                    />
                )
            })
        }

        if (editing && !hidePrivacyButton && !isAssistant) {
            list.push(shortcut => {
                return (
                    <GenericModalItem
                        key={'mbtn-privacy'}
                        icon={'unlock'}
                        text={'Privacy'}
                        visibilityData={{ openPopup, visibilityFn: setShowPrivacy }}
                        shortcut={shortcut}
                    />
                )
            })
        }

        if (!task.calendarData && !isLockedGmailTask && !isAssistant) {
            list.push(shortcut => {
                return (
                    <GenericModalItem
                        key={'mbtn-recurring'}
                        icon={'rotate-cw'}
                        text={'Recurring'}
                        visibilityData={{ openPopup, constant: RECURRING_MODAL_ID, visibilityFn: setShowRecurrence }}
                        shortcut={shortcut}
                    />
                )
            })
        }

        if (editing && !isLockedGmailTask && !isGuide && !isAssistant) {
            list.push(shortcut => {
                return (
                    <GenericModalItem
                        key={'mbtn-project'}
                        icon={'circle'}
                        text={'Project'}
                        visibilityData={{ openPopup, constant: PROJECT_MODAL_ID, visibilityFn: setShowProject }}
                        shortcut={shortcut}
                    />
                )
            })
        }

        if (editing && !task.calendarData && !isLockedGmailTask) {
            list.push(shortcut => {
                return (
                    <GenericModalItem
                        key={'mbtn-workflow'}
                        icon={'workflow'}
                        text={'Workflow'}
                        visibilityData={{ openPopup, constant: TASK_WORKFLOW_MODAL_ID, visibilityFn: setShowWorkflow }}
                        shortcut={shortcut}
                    />
                )
            })
        }

        if (editing) {
            list.push(shortcut => {
                return (
                    <FollowingModalItem
                        key={'mbtn-following'}
                        projectId={projectId}
                        followObjectsType={FOLLOWER_TASKS_TYPE}
                        followObjectId={task.id}
                        followObject={task}
                        closeModal={hideNoModalsProperties}
                        shortcut={shortcut}
                    />
                )
            })
        }

        if (editing) {
            list.push(shortcut => {
                return (
                    <GenericModalItem
                        key={'mbtn-highlight'}
                        icon={'highlight'}
                        text={translate('Highlight')}
                        visibilityData={{
                            openPopup,
                            constant: HIGHLIGHT_MODAL_ID,
                            visibilityFn: setShowHighlight,
                        }}
                        shortcut={shortcut}
                    />
                )
            })
        }

        if (editing) {
            list.push(shortcut => {
                return (
                    <DeleteModalItem
                        key={'mbtn-delete'}
                        projectId={projectId}
                        task={task}
                        shortcut={shortcut}
                        onPress={dismissModal}
                    />
                )
            })
        }

        return list
    }

    const setActiveGoalData = goal => {
        const isPublic = objectIsPublicForLoggedUser(goal)
        setActiveGoal(isPublic ? goal : null)
    }

    // Handler for when a goal is selected from the modal
    const handleGoalSelection = (goal, goalProjectId) => {
        // If updateActiveGoal prop was provided, use it
        if (updateActiveGoal) {
            return updateActiveGoal(goal, goalProjectId)
        }

        // Otherwise handle internally: update local state and save to backend
        setActiveGoal(goal)

        // Use the goal's projectId if the second argument wasn't passed
        const effectiveGoalProjectId = goalProjectId || goal?.projectId

        // Check if the goal is from a different project
        if (goal && effectiveGoalProjectId && effectiveGoalProjectId !== projectId) {
            // Move the task to the goal's project and assign the goal
            const currentProject = ProjectHelper.getProjectById(projectId)
            const newProject = ProjectHelper.getProjectById(effectiveGoalProjectId)
            if (currentProject && newProject) {
                return setTaskProjectWithGoal(currentProject, newProject, task, goal)
            }
            return false
        } else {
            // Same project, just update the parent goal
            return setTaskParentGoal(projectId, task.id, task, goal ? goal : null)
        }
    }

    const setAutoEstimation = autoEstimation => {
        if (editing) setTaskAutoEstimation(projectId, task, autoEstimation)
        setTempAutoEstimation(autoEstimation)
    }

    const selectHighlightColor = (e, data) => {
        const colorValue = data.color
        setTaskHighlight(projectId, task.id, colorValue, task)
        hideHighlightPopup()
        dismissEditMode?.()
    }

    useEffect(() => {
        const { parentGoalId } = task

        if (parentGoalId) {
            const watcherKey = v4()
            Backend.watchGoal(projectId, parentGoalId, watcherKey, setActiveGoalData)
            return () => {
                Backend.unwatch(projectId, watcherKey)
            }
        }
    }, [task.parentGoalId])

    const estimation = task.estimations[task.stepHistory[task.stepHistory.length - 1]]

    return (
        <MoreButtonWrapper
            ref={modalRef}
            projectId={projectId}
            formType={formType}
            object={task}
            objectType={FEED_TASK_OBJECT_TYPE}
            buttonStyle={buttonStyle}
            disabled={disabled}
            shortcut={shortcut}
            wrapperStyle={wrapperStyle}
            onCloseModal={onCloseMainModal}
            customModal={
                showDescription ? (
                    <DescriptionModal
                        projectId={projectId}
                        object={task}
                        closeModal={hideDescriptionPopup}
                        objectType={FEED_TASK_OBJECT_TYPE}
                        updateDescription={saveDescription}
                    />
                ) : showParentGoal ? (
                    <TaskParentGoalModal
                        activeGoal={activeGoal}
                        setActiveGoal={handleGoalSelection}
                        projectId={projectId}
                        closeModal={hideParentGoalPopup}
                        notDelayClose={true}
                        ownerId={task.userId}
                    />
                ) : showPrivacy ? (
                    <PrivacyModal
                        object={task}
                        objectType={FEED_TASK_OBJECT_TYPE}
                        projectId={projectId}
                        delayClosePopover={hidePrivacyPopup}
                        savePrivacyBeforeSaveObject={savePrivacy}
                    />
                ) : showRecurrence ? (
                    <RecurrenceModal
                        task={task}
                        projectId={projectId}
                        saveRecurrenceBeforeSaveTask={saveRecurrenceBeforeSaveTask}
                        closePopover={hideRecurrencePopup}
                    />
                ) : showProject ? (
                    <SelectProjectModal
                        item={{ type: 'task', data: task }}
                        project={project}
                        closePopover={hideProjectPopup}
                    />
                ) : showWorkflow ? (
                    <StatusPicker
                        projectId={projectId}
                        task={task}
                        workflow={workflow}
                        hidePopover={hideWorkflowPopup}
                    />
                ) : showEstimation ? (
                    <EstimationModal
                        projectId={projectId}
                        estimation={estimation}
                        setEstimationFn={setEstimationBeforeSave}
                        closePopover={hideEstimationPopup}
                        autoEstimation={getTaskAutoEstimation(projectId, estimation, task.autoEstimation)}
                        setAutoEstimation={setAutoEstimation}
                        showAutoEstimation={!task.isSubtask}
                        disabled={!!task.calendarData}
                    />
                ) : showHighlight ? (
                    <HighlightColorModal
                        onPress={selectHighlightColor}
                        selectedColor={task.hasStar}
                        onClickOutside={hideHighlightPopup}
                    />
                ) : showPriority ? (
                    <TaskPriorityModal
                        priority={task.priority}
                        setPriority={setPriorityBeforeSave}
                        closeModal={hidePriorityPopup}
                    />
                ) : null
            }
        >
            {renderItems().map((itemFn, index, arr) => {
                const hotkey = index === arr.length - 1 ? '0' : (index + 1).toString()
                return itemFn(hotkey)
            })}
        </MoreButtonWrapper>
    )
}
